

<mydocma-tree
    #mydocmaTreeElement
    [options]="treeOptions"
    [nodeData]="structuresTree"
    [selectedNodeId]="this.selectedStructureTreeNode"
    (nodeSelected) ="this.onClick($event)"
>
    <ng-template mydocmaTreeNodeContent let-data let-node="node">
        <span [ngClass]="data.class ? data.class :''"
            [innerHTML]="data.name + ' - ' + data?.desc | mydocmaHighlight:mydocmaTreeElement?.currentFilter:'i':highlightClass">
        </span>
    </ng-template>
</mydocma-tree>